import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d861dbca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "current-version-wrap" }
const _hoisted_2 = { class: "info-header" }
const _hoisted_3 = { class: "system-list gap-10" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "system-info" }
const _hoisted_6 = { class: "system-name" }
const _hoisted_7 = { class: "system-version" }

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  CurrentVersionService,
  SystemGroupItem,
  VersionData,
} from '@/views/dashboard/setting/version-update/_components/current-version/current-version.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'current-version',
  setup(__props) {

const injector = useReflectiveInjector([CurrentVersionService])
const currentVersionService = injector.get(CurrentVersionService)
const { t, locale } = useI18n()

const versionData = ref<VersionData | null>(null)

const systemGroup = computed<SystemGroupItem[]>(() => {
  void locale.value
  if (!versionData.value) return []
  return formatSystemGroup(versionData.value)
})

function getVersion () {
  currentVersionService.getCurrentVersion().then(res => {
    versionData.value = res
  })
}

function formatSystemGroup (versionData: VersionData): SystemGroupItem[] {
  return [
    {
      groupName: t('terminalDeploy.consoleVersionGroup'),
      systemItems: [
        {
          name: t('terminalDeploy.controlCenter'),
          icon: require('./_images/console.png'),
          version: versionData.console_version
        }
      ]
    },
    {
      groupName: t('terminalDeploy.clientVersionGroup'),
      systemItems: [
        {
          name: t('terminalDeploy.windowsSystem'),
          icon: require('./_images/windows.png'),
          version: versionData.windows_version
        },
        {
          name: t('terminalDeploy.windowsXpSystem'),
          icon: require('./_images/windows.png'),
          version: versionData.windows_xp_version
        },
        {
          name: t('terminalDeploy.windowsServerSystem'),
          icon: require('./_images/windows-server.png'),
          version: versionData.windows_server_version
        },
        {
          name: t('terminalDeploy.windowsServer2003System'),
          icon: require('./_images/windows-server.png'),
          version: versionData.windows_server2003_version
        },
        {
          name: t('terminalDeploy.centosAmd64'),
          icon: require('./_images/centos-amd64.png'),
          version: versionData.centos_amd64_version
        },
        {
          name: t('terminalDeploy.centosAarch64'),
          icon: require('./_images/centos-amd64.png'),
          version: versionData.centos_aarch64_version
        },
        {
          name: t('terminalDeploy.ubuntuAmd64'),
          icon: require('./_images/ubuntu-amd64.png'),
          version: versionData.ubuntu_amd64_version
        },
        {
          name: t('terminalDeploy.ubuntuAarch64'),
          icon: require('./_images/ubuntu-amd64.png'),
          version: versionData.ubuntu_aarch64_version
        },
        {
          name: t('terminalDeploy.uosAarch64'),
          icon: require('./_images/tongxin.png'),
          version: versionData.uos_aarch64_version
        },
        {
          name: t('terminalDeploy.uosAmd64'),
          icon: require('./_images/tongxin.png'),
          version: versionData.uos_amd64_version
        },
        {
          name: t('terminalDeploy.kylinAarch64'),
          icon: require('./_images/qilin-aarch64.png'),
          version: versionData.kylin_aarch64_version
        }
      ]
    }
  ]
}

getVersion()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(systemGroup.value, (groupItem, groupIndex) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: groupIndex }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(groupItem.groupName), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupItem.systemItems, (systemItem, systemIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "system-item el-card",
              key: systemIndex
            }, [
              _createElementVNode("img", {
                class: "system-icon",
                src: systemItem.icon,
                alt: ""
              }, null, 8, _hoisted_4),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(systemItem.name), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('terminalDeploy.versionLabel')) + _toDisplayString(systemItem.version || '--'), 1)
              ])
            ]))
          }), 128))
        ])
      ], 64))
    }), 128))
  ]))
}
}

})